// extracted by mini-css-extract-plugin
export default {"root":"ButtonIcon_root__i5Rqn"};